<script setup lang="ts">
    import { openConsentManager } from '../utils/manageUsercentricsConsent';

    const props = defineProps<{ blok?: CookieButtonStoryblok }>();

    const showCookieBanner = () => {
        openConsentManager();
    };

    const { t } = useI18n();

    const isInFooter = inject('isFooterContext', false);

    const buttonLabel = computed(() => props.blok?.label || t('cookieBanner.buttonText'));
</script>

<template>
    <div
        class="button-wrapper"
        :class="{ '--footer': isInFooter }"
    >
        <PrimaryButton
            v-if="!isInFooter"
            :button-text="buttonLabel"
            product-button
            @click="showCookieBanner"
        />

        <button
            v-else
            type="button"
            class="footer-link footer-cookie-button"
            data-testid="footer-link"
            @click="showCookieBanner"
        >
            <span>{{ buttonLabel }}</span>
        </button>
    </div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/basics/primary-button.scss';
    @import '~/assets/scss/footer/footer-link.scss';

    .button-wrapper {
        max-width: $max-width;
        margin: auto;
        display: flex;
        justify-content: center;
        padding: $spacing--2;

        &.--footer {
            display: block;
            margin: 0;
            max-width: none;
            padding: 0;
        }
    }

    .footer-cookie-button {
        appearance: none;
        background: none;
        border: 0;
        cursor: pointer;
        font: inherit;
    }
</style>
